import { render } from "./updateTables.vue?vue&type=template&id=16d55024"
import script from "./updateTables.vue?vue&type=script&lang=js"
export * from "./updateTables.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__